/* eslint-disable no-console -- literally the point of this file (: */
import { StatusType } from "@datadog/browser-logs";
import { getUserInfo } from "shared/utils/getUserInfo";

export const devLog = (level: StatusType, ...rest: any[]) => {
  if (getUserInfo()?.isDeveloper) {
    switch (level) {
      case "debug":
        console.debug("[DEV]:", ...rest);
        break;

      case "ok":
      case "notice":
      case "info":
        console.log("[DEV]:", ...rest);
        break;

      case "warn":
        console.warn("[DEV]:", ...rest);
        break;

      case "error":
      case "critical":
      case "alert":
      case "emerg":
        console.error("[DEV]:", ...rest);
    }
  }
};
